import { Injectable, signal } from '@angular/core';

import { AppConfig } from './app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

    private static count = 0;

  readonly instanceId: number;

  constructor() {

    AppConfigService.count++;

    this.instanceId =
      AppConfigService.count;

    // console.log(
    //   'AppConfigService Instance:',
    //   this.instanceId
    // );
  }

  // =========================================
  // CONFIG STATE
  // =========================================

  private readonly config = signal<AppConfig | null>(null);

  // =========================================
  // SET CONFIG
  // =========================================

  set(config: AppConfig): void {
    this.config.set(config);
    // console.log(this.config())
  }

  // =========================================
  // GET FULL ENVIRONMENT OBJECT
  // =========================================

  getConfig(): AppConfig {
    return this.config() as AppConfig;
  }

  // =========================================
  // API URL
  // =========================================

  get apiBaseUrl(): string {
    return this.config()?.apiBaseUrl ?? '';
  }

  // =========================================
  // SECRET KEY
  // =========================================

  get secretKey(): string {
    // console.log({"this.config() " :this.config()})
    // console.log({"this.config()?.secretKey": this.config()?.secretKey});
    return this.config()?.secretKey ?? '';
  }

  // =========================================
  // IS PRODUCTION
  // =========================================

  get isProd(): boolean {
    return this.config()?.env === 'prod';
  }

  // =========================================
  // DEBUG FLAG
  // =========================================

  get debug(): boolean {
    return this.config()?.enableDebug ?? false;
  }
}